import React from 'react';
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { withTranslation } from 'react-i18next';
import { formatPriceWithCurrency } from '../../../utils/vat';

/** Confirm refunding a financed invoice (Svea or Resurs). */
const FinancingRefundDialog = ({ t, open, onClose, onConfirm, loading, title, amount, warning, testId }) => (
  <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="xs" fullWidth data-testid={testId}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <Typography variant="body1" sx={{ mb: 2 }}>
        {t('financing.refundAmount')}: <strong>{formatPriceWithCurrency(amount)}</strong>
      </Typography>
      <Alert severity="warning">{warning}</Alert>
    </DialogContent>
    <DialogActions sx={{ flexWrap: 'wrap', gap: 1 }}>
      <Button onClick={onClose} disabled={loading}>{t('Cancel')}</Button>
      <Button
        variant="contained"
        color="warning"
        onClick={onConfirm}
        disabled={loading}
        startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
        data-testid={testId ? `${testId}-confirm` : undefined}
      >
        {t('financing.refundConfirm')}
      </Button>
    </DialogActions>
  </Dialog>
);

export default withTranslation()(FinancingRefundDialog);
